import api from "./api";

export async function loader({ params }) {
  const id = params.id;

  const [draftResponse, originalResponse] = await Promise.all([
    api.get(`/records-drafts/${id}`),
    api.get(`/record/${id}`),
  ]);

  return { draft: draftResponse.data, original: originalResponse.data };
}
